<template>
  <div class="bg-white rounded p-1 shadow-sm">
    <div
      v-if="loadingDonutData"
      class="text-center mt-3"
    >
      <b-spinner
        variant="primary"
        label="Spinning"
      />
    </div>
    <div
      v-else
      class="d-flex align-items-center flex-column justify-content-center"
    >
      <h5 class="text-main text-center">
        Cached data <span class="text-secondary">vs</span> Non-cached data
      </h5>
      <vue-apex-charts
        type="pie"
        width="380"
        height="300"
        :options="chartOptions"
        :series="computedSeries"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import helpers from '@/mixins/helpers'

export default {
  name: 'SimpleDonutChart',
  components: {
    VueApexCharts,
  },
  props: {
    cachedData: {
      type: [String, Number],
      default: 0,
    },
    noCachedData: {
      type: [String, Number],
      default: 0,
    },
    loadingDonutData: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: [Array, Object],
      default: () => ([]),
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        stroke: {
          show: false,
        },
        dataLabels: {
          enabled: true,
          dropShadow: {
            enabled: true,
            left: 0.3,
            top: 0.3,
            opacity: 0.4,
          },
        },
        labels: ['Cached Data', 'Non-cached data'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
          },
        }],
        yaxis: {
          labels: {
            formatter: value => helpers.methods.formatBytes(value),
          },
        },
        noData: {
          text: 'Data Unavailable: Currently, no data is being returned.',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: -15,
          style: {
            color: '#7483A1',
            fontSize: '14px',
            fontFamily: undefined,
          },
        },
        legend: {
          position: 'bottom',
          fontWeight: 600,
        },
        colors: this.colors,
      },

    }
  },
  computed: {
    computedSeries() {
      return [this.cachedData, this.noCachedData] ?? []
    },
    computedLoadingDonutData() {
      return this.loadingDonutData
    },
  },

}
</script>
